import styled from '@emotion/styled'

type InvoiceCurrencyFormItemWrapperProps = {
  isCompactLayout: boolean
}

export const InvoiceCurrencyFormItemWrapper = styled.div<InvoiceCurrencyFormItemWrapperProps>`
  min-width: ${({ isCompactLayout }) => (isCompactLayout ? '80px' : '115px')};
`
